/**********************************
 * Calendly Action Button Handler
 **********************************/
const collection = document.querySelectorAll(".btn-book-a-call");

collection.forEach((element) => {
  element.addEventListener("click", function () {
    handleCalendlyClicked();
  });
});

function handleCalendlyClicked() {
  Calendly.initPopupWidget({
    url: "https://calendly.com/saratel-solutions/discovery-call",
  });
}

export { handleCalendlyClicked };
